module.exports = __webpack_public_path__ + "static/media/1.d2ba62a8.jpg";